import { Select } from 'antd';
import styled from 'styled-components/macro';
import { ThemeModes } from '../../../hooks/theme.hook';

export const TASelect = styled(Select)`
	width: 100%;
	.ta-form &.ant-select-single .ant-select-selector,
	.ta-form &.ant-select-multiple .ant-select-selector {
		background-color: ${({ theme }) => theme.TA_LIGHT} !important;
	}
	&.ant-select:not(.ant-select-customize-input) .ant-select-selector {
		min-height: 44px;
		display: flex;
		align-items: center;
		background-color: ${({ theme }) => theme.TA_LIGHT};
		&:hover {
			border-color: ${({ theme }) => theme.TA_GREEN};
		}
		.ant-select-selection-placeholder {
			color: ${({ theme }) => theme.TA_BLUISH_GREY};
		}
	}
	.ta-form &.ant-select-multiple .ant-select-selector {
		min-height: 44px;
		height: auto;
	}
	&.ant-select-single .ant-select-selector,
	&.ant-select-multiple .ant-select-selector {
		/* background-color: ${({ theme }) => theme.TA_LIGHT} !important; */
		height: 100%;
		border-radius: 0.3rem;

		/* .ant-select-selection__rendered {
			height: 100%;
			position: relative;
			.ant-select-selection-selected-value {
				height: 100%;
				position: absolute;
				top: 19%;
				left: 0; //one way of centering

				// padding-top: 2%; //another way but needs handling for small screens
				// display: flex !important; //another way but with a bug
				// align-items: center;
			}

			ul li {
				&.ant-select-selection__choice,
				&.ant-select-search.ant-select-search--inline {
					margin-top: 10px;
				}
			}
		} */

		.ant-select-selection-overflow {
			.ant-select-selection-overflow-item .ant-select-selection-item {
				background-color: #fafafa;
			}
		}
		.ant-select-selection-item,
		.ant-select-selection-placeholder {
			display: flex;
			align-items: center;
		}
		.ant-select-selection-search {
			height: 100%;
			input {
				height: 100%;
			}
		}
	}
	.ant-select-clear {
		background-color: ${({ theme }) => theme.TA_LIGHT} !important;
	}

	&:not(.ant-select-disabled):hover .ant-select-selector,
	&:not(.ant-select-customize-input).ant-select-focused:not(.ant-select-disabled) .ant-select-selector {
		border-color: ${({ theme }) => theme.TA_GREEN};
	}

	.ant-select-selection.ant-select-selection--multiple input {
		border: none;
		&:hover,
		&:focus {
			border: none;
		}
	}
`;
